// @flow
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import isEmpty from 'ramda/es/isEmpty';

import PlainButton from 'app/common/ui-next/plain-button';

import { RecipientsContext } from './RecipientsData';
import styles from './StatementAction.scss';


type Props = {
  onClick: (e: SyntheticEvent<HTMLButtonElement>) => void,
  disabled?: boolean,
}

const StatementAction = ({ onClick, disabled = false }: Props) => {
  const { t } = useTranslation('statements');

  const [recipients] = useContext(RecipientsContext);
  const createNewDisabled = isEmpty(recipients);

  return (
    <PlainButton
      onClick={onClick}
      className={styles.root}
      disabled={disabled || createNewDisabled}
    >
      {t('add_statement_header')}
    </PlainButton>
  );
};

export default StatementAction;
